import React, { Component, PropTypes } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Grid } from 'semantic-ui-react'

import FooterComponent from '../../gallery/components/FooterComponent'
import LoaderElement from './LoaderComponent'
import Thumbnail from './Thumbnail'

import '../../../node_modules/semantic-ui-css/components/grid.css'

export default class GalleryComponent extends Component {

  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    loadData: PropTypes.func.isRequired,
    persons: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string,
        thumbnail: PropTypes.string,
        icon: PropTypes.string,
        iconAlt: PropTypes.string,
      })
    ),
    scrollToPrevious: PropTypes.func.isRequired,
  }
  componentWillMount () {
    const { loaded, loadData } = this.props
    if (!loaded) {
      loadData()
    }
  }

  componentDidMount () {
    this.props.scrollToPrevious()
  }

  renderList () {
    const { persons } = this.props

    if (persons.length > 0) {
      return persons.map(
        person => <Thumbnail key={person.slug} {...person} />
      )
    }
    return null
  }

  render () {
    const { loaded } = this.props
    return (
      <ReactCSSTransitionGroup
        component='div'
        transitionName='thumbnails'
        transitionEnterTimeout={600}
        transitionLeaveTimeout={600}
      >
        <Grid doubling stackable columns={4} className='galleryColumnMargin push'>
          {loaded && this.renderList()}
        </Grid>
        {!loaded && <LoaderElement />}
        <FooterComponent />
      </ReactCSSTransitionGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/gallery/components/GalleryComponent.js